import { graphql } from '@prophecy/graphql-types/graphql';
import { userGitCredsQuery } from '../../common/git/GitIntegration/queries';
const ExternalSyncFields = `
_id
name
language
syncMode
savedGitCredsStatus {
  ${userGitCredsQuery}
}
externalSyncStatus {
  state
}
`;
const ProjectExternalSyncFields = `
project {
 ${ExternalSyncFields}
}
`;
export const PipelineProjectExternalSyncQuery = graphql(`
  query PipelineProjectExternalSyncQuery($uid: String!) {
    Pipeline(uid: $uid) {
      mode
      path
      ${ProjectExternalSyncFields}
    }
  }
`);
export const PipelineFromOtherProjectQuery = graphql(`
  query PipelineFromOtherProjectQuery($uid: String!, $ownerProjectUID: String) {
    Pipeline(uid: $uid, ownerProjectUID: $ownerProjectUID) {
      repositoryPath
      mode
    }
  }
`);
export const ProjectExternalSyncQuery = graphql(`
  query ProjectExternalSyncQuery($uid: String!) {
    Project(uid: $uid) {
      ${ExternalSyncFields}
    }
  }
`);
export const ConfigurationProjectExternalSyncQuery = graphql(`
  query ConfigurationProjectExternalSyncQuery($uid: String!) {
    Configuration(uid: $uid) {
      ${ProjectExternalSyncFields}
      basePipeline { 
        repositoryPath
        mode
      }
    }
  }
`);
export const JobProjectExternalSyncQuery = graphql(`
  query JobProjectExternalSyncQuery($uid: String!) {
    Job(uid: $uid) {
      ${ProjectExternalSyncFields}
    }
  }
`);
export const GemProjectExternalSyncQuery = graphql(`
  query GemProjectExternalSyncQuery($uid: String!) {
    Gem(uid: $uid ) {
      ${ProjectExternalSyncFields}
    }
  }
`);
export const GemFromOtherProjectQuery = graphql(`
  query GemFromOtherProjectQuery($uid: String!, $ownerProjectUID: String) {
    Gem(uid: $uid, ownerProjectUID: $ownerProjectUID) {
      repositoryPath
    }
  }
`);
export const ObservationProjectExternalSyncQuery = graphql(`
  query ObservationProjectExternalSyncQuery($uid: String!) {
    Project(uid: $uid){
      ${ExternalSyncFields}
    }
  }
`);
